import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { OverdueWalletReportController } from "./controller";
import { StoreSelectorVariantEnum } from "@repo/core/screens/Sales/components/StoreSelector/types";
import { View, VStack } from "@gluestack-ui/themed";
import { ReportCharts } from "@repo/core/components/chart/ReportCharts";
import { DataTable } from "@repo/core/components/core/DataTable";
import { MustShow } from "@repo/core/components/core/MustShow";
import { Modal } from "@repo/core/components/layout/Modal";
import { ReportSelectFilters } from "@repo/core/components/layout/ReportSelectFilters";
import {
  overdueWalletReportChartData,
  overdueWalletReportBarLineData
} from "./mocks";
import { ReportScreenHeader } from "../../components/ReportScreenHeader";
import Spinner from "@repo/core/components/core/Spinner";
import { EmptyState } from "@repo/core/components/layout/EmptyState";

const OverdueWalletReport = () => {
  const {
    isMobile,
    onChangeStartDate,
    onChangeEndDate,
    table,
    handleExportTable,
    filterModalRef,
    topRightText,
    customStyles,
    filterStartDate,
    filterEndDate,
    handleSelectFilters,
    isFetchingOverdueWalletReport,
    hasReportData
  } = OverdueWalletReportController();
  return (
    <Scaffolds.Root showHeader={false}>
      <Scaffolds.StoreSelect
        showHeader={false}
        statusBarVariant={StatusBarVariantEnum.GREEN}
        storeSelectorVariant={StoreSelectorVariantEnum.SHOPKEEPER}
        topRightText={topRightText}
        topRightIcon="refresh"
      >
        <Scaffolds.Page
          showHeader
          pt={!isMobile ? "$3" : "$0"}
          title="Carteiras a Receber X Em Atraso"
          p="$0"
          bg="$backgroundLight0"
          rightIcon={isMobile ? undefined : "file-export"}
          rightIconSize={20}
          rightWebLabel={isMobile ? undefined : "Exportar"}
          onPressRightIcon={isMobile ? undefined : handleExportTable}
        >
          <VStack flex={1} px={isMobile ? 0 : "$4"} gap={isMobile ? 0 : "$6"}>
            <ReportScreenHeader
              filterModalRef={filterModalRef}
              defaultStartDate={filterStartDate}
              defaultEndDate={filterEndDate}
              onChangeStartDate={onChangeStartDate}
              onChangeEndDate={onChangeEndDate}
              handleSelectFilter={handleSelectFilters}
            />
            <ReportCharts.Bar
              data={overdueWalletReportChartData}
              lineData={overdueWalletReportBarLineData}
              maxValue={1000}
              maxDomain={800}
              numberOfGridLines={10}
              showRightLabels
              leftLabelsTransform={(value) => `R$${value}M`}
              rightLabelsTransform={(tick) =>
                `${Math.round((tick / 1000) * 100)}%`
              }
              lineDataPercentage
              customStyles={customStyles}
            />

            <MustShow
              isVisible={!isFetchingOverdueWalletReport && hasReportData}
              fallback={
                <MustShow
                  isVisible={isFetchingOverdueWalletReport}
                  fallback={
                    <EmptyState
                      flex={1}
                      text="Nenhum relatório disponível para o período selecionado."
                    />
                  }
                >
                  <VStack flex={1} alignItems="center" justifyContent="center">
                    <Spinner size={60} />
                  </VStack>
                </MustShow>
              }
            >
              <MustShow isVisible={!isMobile}>
                <DataTable table={table} />
              </MustShow>
            </MustShow>
          </VStack>
        </Scaffolds.Page>
      </Scaffolds.StoreSelect>

      <Modal ref={filterModalRef}>
        <View flex={1} p="$2" bg="$backgroundLight0">
          <ReportSelectFilters
            onClose={() => filterModalRef.current?.close()}
          />
        </View>
      </Modal>
    </Scaffolds.Root>
  );
};
export default OverdueWalletReport;
